
    import {Component, Vue} from 'vue-property-decorator';
    import NtdUserTable from "@/components/ntd/NtdUsersTable.vue";
    import {currentUserModule} from "@/store";

    @Component({
        name: 'NtdUsers',
        components: {
          NtdUserTable
        }
    })
    export default class UsersEditor extends Vue {
        get canSeeUsers(){
            return currentUserModule.hasRight("UserGetAllCmd")
        }

        async mounted() {
            await currentUserModule.load();
        }
    }
